module.exports = __webpack_public_path__ + "static/media/6.cdf93a85.jpg";